<template>
  <div class="solution-module">
    <div class="solution-module-background"></div>
    <div class="solution-module-content">
      <div v-movein class="solution-module-content-title">行业解决方案</div>
      <div v-movein class="solution-module-content-sub-title">SOLUTION</div>
      <div v-movein class="solution-module-content-description">
        完善、成熟的行业解决方案，赋能客户业务数智升级。
      </div>
      <div class="solution-item-wrapper">
        <div v-movein class="solution-item">
          <div class="image-box">
            <img
              v-lazyload
              class="solution-image"
              :data-src="img1"
              alt="图片1"
              srcset=""
            />
          </div>
          <div class="solution-item-title">反诈中心解决方案</div>
          <div class="solution-item-description">
            满足预警宣防、侦查打击、行业联动等业务闭环的侦查需求，遏制电信网络诈骗犯罪案件高发态势。
          </div>
          <div class="solution-tags-wrapper">
            <div class="solution-tag">
              <FolderFilledIcon class="tag-icon" />
              产品齐全
            </div>
            <div class="solution-tag">
              <SealFilledIcon class="tag-icon" />
              贴近实战
            </div>
            <div class="solution-tag">
              <ComputerFilledIcon class="tag-icon" />
              自主研发
            </div>
          </div>
          <button class="show-detail-button" @click="toSolutionDetail(1)">
            查看详情
            <span class="arrow-right"> → </span>
          </button>
        </div>
        <div v-movein class="solution-item">
          <div class="image-box">
            <img
              v-lazyload
              class="solution-image"
              :data-src="img3"
              alt="图片3"
              srcset=""
            />
          </div>
          <div class="solution-item-title">反诈联盟解决方案</div>
          <div class="solution-item-description">
            公安机关牵头，银行、运营商等部门密切协作，实现反诈联盟成员的数据共享和业务协同。
          </div>
          <div class="solution-tags-wrapper">
            <div class="solution-tag">
              <ApartmentFilledIcon class="tag-icon" />
              打造信任体系
            </div>
            <div class="solution-tag">
              <InfoShareFilledIcon class="tag-icon" />
              多方信息共享
            </div>
            <div class="solution-tag">
              <SafetyFilledIcon class="tag-icon" />
              实现联防联控
            </div>
            <div class="solution-tag">
              <LineChartFilledIcon class="tag-icon" />
              提升业务效率
            </div>
          </div>
          <button class="show-detail-button" @click="toSolutionDetail(3)">
            查看详情
            <span class="arrow-right"> → </span>
          </button>
        </div>
        <div v-movein class="solution-item">
          <div class="image-box">
            <!-- todo class 添加 no-right-click 并添加蒙层，可以点击 -->
            <img
              v-lazyload
              class="solution-image"
              :data-src="img2"
              alt="图片2"
              srcset=""
            />
          </div>
          <div class="solution-item-title">侦查中心解决方案</div>
          <div class="solution-item-description">
            具有案件研判、信息收集分析、跨部门协作、技术支撑等能力；支持省市县三级侦查中心的建设。
          </div>
          <div class="solution-tags-wrapper">
            <div class="solution-tag">
              <LineChartFilledIcon class="tag-icon" />
              数据汇聚与治理
            </div>
            <div class="solution-tag">
              <ApplicationFilledIcon class="tag-icon" />
              一体化平台建设
            </div>
            <div class="solution-tag">
              <CollaborationFilledIcon class="tag-icon" />
              跨部门协同作战
            </div>
            <div class="solution-tag">
              <ComputerFilledIcon class="tag-icon" />
              技术与基础支撑
            </div>
          </div>
          <button class="show-detail-button" @click="toSolutionDetail(2)">
            查看详情
            <span class="arrow-right"> → </span>
          </button>
        </div>
        <div v-movein class="solution-item">
          <div class="image-box">
            <img
              v-lazyload
              class="solution-image"
              :data-src="img4"
              alt="图片4"
              srcset=""
            />
          </div>
          <div class="solution-item-title">警校数据侦查实验室</div>
          <div class="solution-item-description">
            构筑集“实战、教学、科研”于一体的数据侦查实验室，提升公安信息化教学能力。
          </div>
          <div class="solution-tags-wrapper">
            <div class="solution-tag">
              <SealFilledIcon class="tag-icon" />
              贴近实战
            </div>
            <div class="solution-tag">
              <LineChartFilledIcon class="tag-icon" />
              提升能力
            </div>
            <div class="solution-tag">
              <ComputerFilledIcon class="tag-icon" />
              创新科研
            </div>
          </div>
          <button class="show-detail-button" @click="toSolutionDetail(4)">
            查看详情
            <span class="arrow-right"> → </span>
          </button>
        </div>
        <div v-movein class="solution-item">
          <div class="image-box">
            <img
              v-lazyload
              class="solution-image"
              :data-src="img5"
              alt="图片5"
              srcset=""
            />
          </div>
          <div class="solution-item-title">防控治理中心解决方案</div>
          <div class="solution-item-description">
            整合资源、统一标准、融合业务、赋能基层，支持省市县三级防控治理中心建设。
          </div>
          <div class="solution-tags-wrapper">
            <div class="solution-tag">
              <ApplicationFilledIcon class="tag-icon" />
              塑造标准体系
            </div>
            <div class="solution-tag">
              <CollaborationFilledIcon class="tag-icon" />
              整合多方数据
            </div>
            <div class="solution-tag">
              <SafetyFilledIcon class="tag-icon" />
              实现基层赋能
            </div>
            <div class="solution-tag">
              <LineChartFilledIcon class="tag-icon" />
              提升业务效率
            </div>
          </div>
          <button class="show-detail-button" @click="toSolutionDetail(5)">
            查看详情
            <span class="arrow-right"> → </span>
          </button>
        </div>
        <div v-movein class="more-solution">
          <div class="more-solution-content">
            <div class="more-solution-title">更多方案</div>
            <div class="more-solution-waiting">让我们敬请期待</div>
            <img v-lazyload class="more-solution-image" :data-src="rocketImg" />
          </div>
          <img
            v-lazyload
            class="more-background none-right-click"
            :data-src="moreImg"
            alt=""
            srcset=""
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FolderFilledIcon from '@/assets/icon/svg/folderFilled.svg?inline'
import SealFilledIcon from '@/assets/icon/svg/sealFilled.svg?inline'
import ComputerFilledIcon from '@/assets/icon/svg/computerFilled.svg?inline'
import LineChartFilledIcon from '@/assets/icon/svg/lineChartFilled.svg?inline'
import ApplicationFilledIcon from '@/assets/icon/svg/applicationFilled.svg?inline'
import CollaborationFilledIcon from '@/assets/icon/svg/collaborationFilled.svg?inline'
import ApartmentFilledIcon from '@/assets/icon/svg/apartmentFilled.svg?inline'
import InfoShareFilledIcon from '@/assets/icon/svg/infoShareFilled.svg?inline'
import SafetyFilledIcon from '@/assets/icon/svg/safetyFilled.svg?inline'
import img1 from '@/assets/images/solution/solution-1.png'
import img2 from '@/assets/images/solution/solution-2.png'
import img3 from '@/assets/images/solution/solution-3.png'
import img4 from '@/assets/images/solution/solution-4.png'
import img5 from '@/assets/images/solution/solution-5.png'
import rocketImg from '@/assets/images/solution/rocket.svg'
import moreImg from '@/assets/images/solution/more-solution.svg'

export default {
  name: 'SolutionModule',
  components: {
    FolderFilledIcon,
    SealFilledIcon,
    ComputerFilledIcon,
    LineChartFilledIcon,
    ApplicationFilledIcon,
    CollaborationFilledIcon,
    ApartmentFilledIcon,
    InfoShareFilledIcon,
    SafetyFilledIcon
  },
  data() {
    return {
      img1,
      img2,
      img3,
      img4,
      img5,
      rocketImg,
      moreImg
    }
  },
  methods: {
    toSolutionDetail(id) {
      this.$router.push({
        path: `/solution/${id}`
      })
    }
  }
}
</script>
<style lang="less" scoped>
.solution-module {
  position: relative;
  overflow: hidden;
  .solution-module-background {
    position: absolute;
    top: 0;
    left: 50%;
    width: 1440px;
    height: 1440px;
    border-radius: 50%;
    opacity: 0.2;
    background: linear-gradient(
      180deg,
      rgba(226, 76, 79, 0.8) 0%,
      rgba(66, 12, 13, 0.2) 66.15%
    );
    transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    z-index: 0;
  }
  .solution-module-content {
    position: relative;
    max-width: 1280px;
    margin: 0 auto;
    z-index: 1;
    .solution-module-content-title {
      margin-top: 104px;
      font-family: SourceHanSansCN;
      font-weight: 600;
      font-size: 48px;
      line-height: 64px;
      letter-spacing: 0px;
      text-align: center;
      vertical-align: middle;
      color: transparent;
      background: linear-gradient(
        167.78deg,
        #ffffff 68.32%,
        rgba(255, 255, 255, 0.38) 96.13%
      );
      background-clip: text;
      text-shadow: 0px 2px 6px #00000014, 0px 6px 2px #0000000f;
    }
    .solution-module-content-sub-title {
      display: flex;
      font-family: Times;
      font-weight: 500;
      font-size: 12px;
      line-height: 32px;
      letter-spacing: 0%;
      text-transform: uppercase;
      text-align: center;
      color: #ffffff;
      justify-content: center;
      align-items: center;
      &::before,
      &::after {
        content: '';
        display: inline-block;
        width: 14px;
        height: 2px;
        background-color: #f02528;
        vertical-align: middle;
        margin: 0 9px;
      }
    }
    .solution-module-content-description {
      margin-top: 24px;
      padding: 0 16px;
      font-weight: 500;
      font-size: 16px;
      line-height: 48px;
      letter-spacing: 0%;
      text-align: center;
      color: #ffeff0;
    }
    .solution-item-wrapper {
      display: flex;
      display: -ms-flexbox;
      margin-top: 82px;
      width: 100%;
      flex-wrap: wrap;
      -ms-flex-wrap: wrap;
      justify-content: space-between;
      -ms-flex-pack: space-between;
      align-items: start;
      .solution-item {
        position: relative;
        margin-bottom: 20px;
        padding: 30px;
        width: 415px;
        height: 618px;
        border: 1px solid #262626;
        border-radius: 12px;
        background-color: #141414;
        transition: all 0.3s;
        flex-shrink: 0;
        -ms-flex-shrink: 0;
        &:hover {
          box-shadow: 0px 0px 24px 0px #e2e2e23d;
        }
        .image-box {
          width: 100%;
          height: 255px;
          border-radius: 10px;
          overflow: hidden;
          .solution-image {
            width: 100%;
          }
        }
        .solution-item-title {
          margin-top: 20px;
          font-weight: 600;
          font-size: 24px;
          line-height: 36px;
          letter-spacing: 0%;
          color: #ffffff;
        }
        .solution-item-description {
          margin-top: 4px;
          font-weight: 400;
          font-size: 16px;
          line-height: 24px;
          letter-spacing: 0%;
          color: #ddcaca;
        }
        .solution-tags-wrapper {
          display: flex;
          display: -ms-flexbox;
          margin-top: 24px;
          height: 114px;
          flex-wrap: wrap;
          -ms-flex-wrap: wrap;
          justify-content: space-between;
          -ms-flex-pack: space-between;
          .solution-tag {
            display: flex;
            display: -ms-flexbox;
            padding: 0 14px;
            margin-bottom: 24px;
            height: 35px;
            border-radius: 17px;
            border: 1px solid #262626;
            background-color: #1a1a1a;
            color: #ffffff;
            align-items: center;
            -ms-align-items: center;
            .tag-icon {
              margin-right: 4px;
              width: 20px;
              height: 20px;
              vertical-align: middle;
            }
          }
        }
        .show-detail-button {
          width: 100%;
          height: 48px;
          border-radius: 8px;
          padding: 0;
          border: none;
          background-color: #d2153d;
          color: white;
          text-align: center;
          font-weight: 400;
          font-size: 20px;
          line-height: 48px;
          letter-spacing: 0px;
          cursor: pointer;
          .arrow-right {
            margin-left: 52px;
          }
        }
      }
      .more-solution {
        position: relative;
        padding: 30px;
        width: 413px;
        height: 618px;
        .more-background {
          position: absolute;
          left: 0;
          top: 0;
          margin: 30px;
          object-fit: cover;
          z-index: 0;
        }
        .more-solution-content {
          position: relative;
          display: flex;
          display: -ms-flexbox;
          width: 100%;
          height: 100%;
          flex-direction: column;
          -ms-flex-direction: column;
          justify-content: center;
          -ms-flex-pack: center;
          align-items: center;
          -ms-align-items: center;
          z-index: 1;
          .more-solution-title {
            font-weight: 400;
            font-size: 14px;
            line-height: 15px;
            letter-spacing: 0px;
            text-align: center;
            color: #ddcaca;
          }
          .more-solution-waiting {
            margin-top: 8px;
            font-weight: 500;
            font-size: 18px;
            line-height: 26px;
            letter-spacing: 0px;
            text-align: center;
            color: #ffffff;
          }
          .more-solution-image {
            margin-top: 48px;
          }
        }
      }
    }
  }
}
@media screen and (min-width: 1024.02px) and (max-width: 1279px) {
  .solution-module {
    .solution-module-content {
      .solution-item-wrapper {
        justify-content: space-around;
      }
    }
  }
}
@media screen and (min-width: 768.02px) and (max-width: 1024px) {
  .solution-module {
    .solution-module-content {
      .solution-item-wrapper {
        justify-content: space-around;
        .solution-item {
          width: 360px;
          height: 585px;
          .image-box {
            height: 207px;
          }
          .solution-item-description {
            height: 72px;
          }
          .solution-tags-wrapper {
            .solution-tag {
              // padding: 0 12px;
              font-size: 14px;
              .tag-icon {
                height: 16px;
                width: 16px;
              }
            }
          }
        }
        .more-solution {
          width: 360px;
          height: 585px;
          .more-background {
            width: 300px;
            height: 525px;
          }
        }
      }
    }
  }
}

@media screen and (min-width: 430.02px) and (max-width: 768px) {
  .solution-module {
    .solution-module-content {
      .solution-item-wrapper {
        justify-content: space-around;
      }
    }
  }
}

@media screen and (max-width: 430px) {
  .solution-module {
    .solution-module-content {
      .solution-item-wrapper {
        justify-content: space-around;
        .solution-item {
          width: calc(100% - 20px);
          height: auto;
          .image-box {
            height: auto;
          }
          .solution-tags-wrapper {
            height: auto;
          }
        }
        .more-solution {
          width: 100%;
          .more-background {
            width: calc(100% - 60px);
            height: calc(100% - 60px);
          }
        }
      }
    }
  }
}
</style>
